// extracted by mini-css-extract-plugin
export default {"subTitle":"styles__subTitle___HwFFL","green":"styles__green___k67oa","red":"styles__red___N2e0L","gold":"styles__gold___jw3cr"};